export const faqRoute = {
  path: "/faq",
  link: "/faq",
};
